// extracted by mini-css-extract-plugin
export default {"headerMain":"IdGFjfF69ggbEiiU"};